var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleAndRabbit = function SvgPeopleAndRabbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 978 306"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#people-and-rabbit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m609.884 151.122-.044-55.8c7.188-.005 14.085 2.928 19.172 8.156 5.088 5.228 7.949 12.322 7.955 19.722.006 7.399-2.844 14.498-7.923 19.735-5.079 5.236-11.971 8.181-19.16 8.187Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m620.485 105.832-10.667.007M620.491 123.215l-10.659.007M620.499 137.563l-10.659.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M389.817 304.985h-68.245V203.143c0-8.251 3.184-16.163 8.852-21.998 5.668-5.834 13.356-9.111 21.371-9.111h43.986c9.074 0 18.893 9.446 18.893 22.763-.03 29.045-24.857 110.188-24.857 110.188ZM411.725 85.466l21.325 24.182a3.757 3.757 0 0 1 .614 3.945 3.63 3.63 0 0 1-1.313 1.585 3.5 3.5 0 0 1-1.94.593h-17.912s-.391-30.305-.774-30.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M372.804 159.378c25.787 0 46.691-21.518 46.691-48.06s-20.904-48.06-46.691-48.06-46.691 21.517-46.691 48.06c0 26.542 20.904 48.06 46.691 48.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M394.837 106.583c4.82 0 8.728-4.022 8.728-8.984s-3.908-8.984-8.728-8.984-8.728 4.022-8.728 8.984 3.908 8.984 8.728 8.984Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M403.566 97.607c0-2.383-.92-4.668-2.557-6.353a8.6 8.6 0 0 0-6.171-2.631v17.96a8.6 8.6 0 0 0 6.169-2.629 9.12 9.12 0 0 0 2.559-6.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M396.561 159.537h-48.563v12.542h48.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M381.243 172.079h-51.084c-91.818 0-104.718 56.308-171.592 56.308-24.746 0-48.703-18.916-48.703-47.195 0-15.585 7.792-28.939 25.527-28.939 3.246.001 6.434.884 9.241 2.56a18.7 18.7 0 0 1 6.748 6.985s-.56-27.042-22.188-27.042c-29.486 0-36.607 25.039-52.183 25.039-13.202 0-20.249-28.158-42.201-28.158C16.505 131.637 0 148.011 0 177.353 0 228.319 27.731 305 138.804 305c76.84 0 130.268-37.817 191.024-87.623 24.731-20.259 51.415-45.298 51.415-45.298Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M399.998 120.21s5.278 8.817 15.819 8.817"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M361.84 29.883 306.816 64.93l22.107 36.771 55.023-35.049z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m314.576 109.861 82.84-52.765M361.592 29.462c3 4.993-6.885 16.883-22.115 26.557s-29.957 13.483-32.957 8.49M351.766 172.064c-36.039 0-100.392 52.643-119.108 61.073M76.988 159.825s-14.175 10.547-14.175 38.098c0 36.474 37.697 60.147 70.876 60.147"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.918 243.161s31.395 41.618 96.905 41.618 90.61-25.442 90.61-25.442M338.137 144.589h24.48v-15.061c0-14.219-11.212-17.125-11.212-29.114 0-6.374 4.062-9.705 8.706-9.705 9.008 0 9.627 13.727 9.627 13.727h7.43l7.74-22.005s14.692 7.156 19.078-7.071"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M358.637 116.545c2.882 4.083 5.661 6.457 8.845 6.457 3.959 0 5.16-4.135 5.16-7.033M379.475 111.78a7.53 7.53 0 0 1 2.285-4.917 7.12 7.12 0 0 1 4.928-1.995c1.828 0 3.589.713 4.927 1.995a7.54 7.54 0 0 1 2.286 4.917M364.296 101.711s-1.003-4.757-4.173-4.757-4.253 2.997-2.263 8.392 5.794 10.729 8.603 10.076c2.808-.652 1.998-4.196 1.998-4.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M776.701 304.545v-1.002c-.182-17.438-7.039-34.099-19.083-46.364s-28.302-19.145-45.244-19.145c-16.943 0-33.201 6.88-45.245 19.145s-18.901 28.926-19.082 46.364v1.002z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m406.978 178.552 78.064 82.948h75.24v43.007h-81.491a55.65 55.65 0 0 1-21.922-4.511 57 57 0 0 1-18.555-12.835l-55.072-57.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m483.028 192.088-53.753 63.736-32.25-63.053c-2.033-3.971-5.08-7.295-8.814-9.614a23.43 23.43 0 0 0-12.372-3.543 23.4 23.4 0 0 0-11.761 3.187 24.3 24.3 0 0 0-8.724 8.723 25.2 25.2 0 0 0-3.437 12.009 25.24 25.24 0 0 0 2.737 12.198l31.262 63.145c3.558 7.196 8.966 13.25 15.635 17.502s14.344 6.538 22.188 6.611a41.9 41.9 0 0 0 19.694-4.722c6.106-3.167 11.386-7.792 15.402-13.488l52.676-69.807z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-bg, #090909)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m428.914 256.196-6.17 31.747M412.139 274.93l17.345-19.348M437.141 279.908l-8.028-24.137"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m483.139 192.164-1.143 7.587a15.35 15.35 0 0 0 .821 7.724 14.9 14.9 0 0 0 4.479 6.253l15.945 13.051"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m483.229 192.209 25.8-23.423a5.82 5.82 0 0 1 2.997-1.431 5.74 5.74 0 0 1 3.276.453 5.9 5.9 0 0 1 1.986 1.51c.55.643.96 1.4 1.203 2.22a6.18 6.18 0 0 1-.624 4.927l-8.109 13.536h20.95l17.994-23.309a6.73 6.73 0 0 1 3.834-2.455 6.58 6.58 0 0 1 4.481.581 6.8 6.8 0 0 1 2.192 1.814 7 7 0 0 1 1.283 2.577c.247.942.298 1.927.15 2.891a7.1 7.1 0 0 1-1.008 2.703l-14.743 23.378c-3.77 5.963-9.544 10.286-16.218 12.14l-17.109 4.773z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m515.957 168.164-4.851 4.864a4.07 4.07 0 0 1-2.786 1.207 4.06 4.06 0 0 1-2.838-1.071l-.502-.455M559.758 166.123l-5.322 7.201a4.9 4.9 0 0 0-.817 1.73 5 5 0 0 0-.104 1.921 5 5 0 0 0 .624 1.813 4.8 4.8 0 0 0 1.255 1.425l.87.653M560.281 304.507l-7.895-6.245a24.34 24.34 0 0 1-6.856-8.59 25.1 25.1 0 0 1-2.454-10.827v-17.451"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M552.255 288.869c1.25 0 2.263-1.043 2.263-2.33 0-1.286-1.013-2.329-2.263-2.329s-2.263 1.043-2.263 2.329 1.013 2.33 2.263 2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M731.174 304.848h-54.217a28.6 28.6 0 0 1 1.934-10.82 28 28 0 0 1 5.846-9.21 27.1 27.1 0 0 1 8.85-6.169 26.45 26.45 0 0 1 10.478-2.169c3.598 0 7.16.738 10.479 2.169a27.1 27.1 0 0 1 8.85 6.169 28 28 0 0 1 5.846 9.21 28.6 28.6 0 0 1 1.934 10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m690.115 293.907.008 10.972M704.055 293.892l.007 10.971M717.994 293.884l.008 10.972M560.348 304.507v-30.245h20.478c6.341-.001 12.55 1.877 17.883 5.41l19.534 12.899a6.4 6.4 0 0 1 2.116 2.342c.503.951.767 2.016.766 3.099v.531c-.339 4.295-5.094 6.632-8.72 4.469l-17.751-10.623"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M560.502 291.441h30.849c1.684 0 3.298.688 4.488 1.913a6.63 6.63 0 0 1 1.859 4.62 6.7 6.7 0 0 1-.474 2.509 6.6 6.6 0 0 1-1.374 2.13 6.3 6.3 0 0 1-2.063 1.424c-.772.33-1.6.5-2.436.5h-30.849z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M596.535 294.286h-4.791c-.503 0-1 .102-1.464.3a3.8 3.8 0 0 0-1.242.854 3.9 3.9 0 0 0-.829 1.277c-.192.478-.291.99-.291 1.507 0 1.044.403 2.046 1.12 2.785a3.78 3.78 0 0 0 2.706 1.153h4.201M613.628 289.612a4.9 4.9 0 0 0-.775 1.784 5 5 0 0 0-.026 1.955c.12.647.368 1.261.728 1.805.36.545.824 1.008 1.363 1.361l5.794 3.794M577.059 170.691l43.462 87.045M600.553 72.757l30.002-28.272M631.033 87.265 739.15 49.789M653.412 113.867h293.634M445.398 114.087h23.589M50.914 113.867h243.081M468.986 152.025l-42.017 19.728M461.616 63.25l-39.069-18.97M728.461 172.057 952 223.273M551.428 212.939v36.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m686.068 160.523-16.902.38c-.31-14.872-26.7-35.579-27.371-67.644-.575-27.316 4.689-42.544 8.271-49.532 2.772-5.41 5.698-8.696 11.102-8.81 6.051-.136 9.944 3.255 11.727 14.5 5.898 37.278 19.955 63.456 13.173 111.106Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M675.829 163.08c-.339-16.518-24.399-36.701-27.061-63.167-2.211-22.201 3.929-43.758 5.359-49.464 1.254-5.015 3.17-8.612 6.635-8.589 3.037 0 5.116 2.565 5.691 8.984 1.533 17.186 3.103 44.122 5.226 62.643 2.278 19.857 6.701 44.085 13.438 51.991"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M675.829 163.08c-.339-16.518-24.399-36.701-27.061-63.167-2.211-22.201 3.929-43.758 5.359-49.464 1.254-5.015 3.17-8.612 6.635-8.589 3.037 0 5.116 2.565 5.691 8.984 1.533 17.186 3.103 44.122 5.226 62.643 2.278 19.857 6.701 44.085 13.438 51.991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m694.936 160.462 16.91.137c.118-14.872 26.235-35.943 26.479-68.016.213-27.315-5.256-42.49-8.927-49.41-2.846-5.373-5.809-8.613-11.212-8.658-6.06-.053-9.907 3.4-11.536 14.667-5.404 37.354-19.115 63.729-11.714 111.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M705.211 162.876c.126-16.519 23.92-37.043 26.228-63.54 1.931-22.231-4.512-43.697-6.008-49.387-1.319-5-3.288-8.567-6.737-8.499-3.038.061-5.087 2.64-5.573 9.106-1.298 17.208-2.514 44.16-4.423 62.704-2.02 19.895-6.126 44.175-12.753 52.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M705.211 162.876c.126-16.519 23.92-37.043 26.228-63.54 1.931-22.231-4.512-43.697-6.008-49.387-1.319-5-3.288-8.567-6.737-8.499-3.038.061-5.087 2.64-5.573 9.106-1.298 17.208-2.514 44.16-4.423 62.704-2.02 19.895-6.126 44.175-12.753 52.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M689.437 248.282c25.786 0 46.691-21.517 46.691-48.06s-20.905-48.06-46.691-48.06-46.691 21.517-46.691 48.06 20.904 48.06 46.691 48.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M670.846 204.881s1.725 8.635 8.388 8.635c8.205 0 8.728-8.567 8.728-8.567-5.455 1.123-8.374-4.818-8.374-4.818s-2.056 5.797-8.742 4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M675.387 204.729v12.747h8.521v-12.701c-4.74-2.8-4.298-6.465-4.298-6.465a8.35 8.35 0 0 1-1.328 3.756 8.06 8.06 0 0 1-2.895 2.663Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M679.654 197.65a7.6 7.6 0 0 0 .478 2.897c.347.923.87 1.765 1.538 2.475a7.2 7.2 0 0 0 2.355 1.662 7 7 0 0 0 5.596 0 7.2 7.2 0 0 0 2.354-1.662 7.4 7.4 0 0 0 1.538-2.475 7.6 7.6 0 0 0 .479-2.897"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M679.654 197.65a7.6 7.6 0 0 0 .478 2.897c.347.923.87 1.765 1.538 2.475a7.2 7.2 0 0 0 2.355 1.662 7 7 0 0 0 5.596 0 7.2 7.2 0 0 0 2.354-1.662 7.4 7.4 0 0 0 1.538-2.475 7.6 7.6 0 0 0 .479-2.897"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M665.318 197.65a7.6 7.6 0 0 0 .478 2.897c.347.923.87 1.765 1.539 2.475a7.2 7.2 0 0 0 2.354 1.662 7 7 0 0 0 5.596 0 7.2 7.2 0 0 0 2.354-1.662 7.4 7.4 0 0 0 1.538-2.475 7.6 7.6 0 0 0 .479-2.897v-4.151"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M665.318 197.65a7.6 7.6 0 0 0 .478 2.897c.347.923.87 1.765 1.539 2.475a7.2 7.2 0 0 0 2.354 1.662 7 7 0 0 0 5.596 0 7.2 7.2 0 0 0 2.354-1.662 7.4 7.4 0 0 0 1.538-2.475 7.6 7.6 0 0 0 .479-2.897v-4.151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M679.671 193.545c2.007 0 3.634-1.675 3.634-3.741s-1.627-3.741-3.634-3.741-3.634 1.675-3.634 3.741 1.627 3.741 3.634 3.741ZM662.714 193.325c4.295 0 7.777-3.584 7.777-8.005s-3.482-8.005-7.777-8.005-7.776 3.584-7.776 8.005 3.481 8.005 7.776 8.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M657.216 179.66a8.13 8.13 0 0 0-2.278 5.664c0 2.124.819 4.161 2.278 5.664l11.006-11.328a7.67 7.67 0 0 0-5.503-2.346 7.67 7.67 0 0 0-5.503 2.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M698.96 193.325c4.295 0 7.777-3.584 7.777-8.005s-3.482-8.005-7.777-8.005-7.776 3.584-7.776 8.005 3.481 8.005 7.776 8.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M693.146 179.41a8.13 8.13 0 0 0-2.279 5.664c0 2.124.82 4.162 2.279 5.664l11.005-11.328a7.67 7.67 0 0 0-5.503-2.346 7.67 7.67 0 0 0-5.502 2.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M679.705 198.955v17.831M251.271 304.431h555.424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M283.369 146.039v.584c-8.109 0-12.864 5.068-12.856 13.392h-.811c0-8.346-4.873-13.384-12.915-13.377v-.592c8.05 0 12.915-5.076 12.915-13.392h.803c0 8.316 4.718 13.385 12.864 13.385ZM783.991 223.167v.592c-8.108 0-12.863 5.068-12.863 13.392h-.811c0-8.346-4.865-13.385-12.915-13.377v-.592c8.05 0 12.915-5.076 12.908-13.392h.811c.007 8.316 4.747 13.385 12.87 13.377ZM624.813 178.355v.197c-3.03 0-4.799 1.889-4.799 4.992h-.302c0-3.118-1.813-4.992-4.814-4.985v-.22c3.001 0 4.814-1.897 4.814-5h.302c0 3.126 1.769 5.016 4.799 5.016ZM877.617 290.159v.22c-3.029 0-4.799 1.889-4.799 4.992h-.302c0-3.118-1.813-4.992-4.821-4.992v-.22c3.008 0 4.821-1.89 4.821-4.993h.302c0 3.103 1.77 4.993 4.799 4.993ZM459.87 190.04v.22c-3.03 0-4.799 1.889-4.792 4.992h-.302c0-3.118-1.821-4.985-4.821-4.985v-.22c3 0 4.814-1.897 4.814-5h.317c0 3.103 1.754 4.993 4.784 4.993ZM444.264 151.001c1.547 0 2.801-1.291 2.801-2.883s-1.254-2.884-2.801-2.884-2.801 1.291-2.801 2.884 1.254 2.883 2.801 2.883ZM739.411 145.083c1.547 0 2.801-1.291 2.801-2.884s-1.254-2.883-2.801-2.883-2.802 1.291-2.802 2.883 1.254 2.884 2.802 2.884ZM878.619 245.885c1.548 0 2.802-1.291 2.802-2.884s-1.254-2.883-2.802-2.883c-1.547 0-2.801 1.291-2.801 2.883s1.254 2.884 2.801 2.884ZM468.738 178.779c4.002 0 7.246-3.339 7.246-7.458 0-4.12-3.244-7.459-7.246-7.459s-7.246 3.339-7.246 7.459 3.244 7.458 7.246 7.458ZM762.113 88.281c4.002 0 7.246-3.339 7.246-7.458 0-4.12-3.244-7.459-7.246-7.459s-7.246 3.34-7.246 7.459 3.244 7.458 7.246 7.458ZM450.596 88.092c2.162 0 3.914-1.804 3.914-4.03 0-2.224-1.752-4.028-3.914-4.028s-3.914 1.804-3.914 4.029 1.752 4.029 3.914 4.029ZM464.904 24.993v.22c-3.029 0-4.798 1.89-4.798 4.992h-.303c0-3.118-1.813-4.992-4.821-4.992v-.22c3.008 0 4.821-1.89 4.821-4.993h.295c-.015 3.103 1.777 4.993 4.806 4.993Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "people-and-rabbit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 20h978v285H0z"
  })))));
};
export default SvgPeopleAndRabbit;